import { FETCH_ROOMS, FETCH_CODE_PROMOS, FETCH_ACTIVITES, FETCH_OFFRES, FETCH_FORMULES, FETCH_ACCESSOIRES, FETCH_ARTICLES, FETCH_TACHES, FETCH_CONFIGURATIONS } from '../actions/constants.js'

const initialState = {
    activites: [],
    offres: [],
    formules: [],
    accessoires: [],
    articles: [],
    taches: [],
    rooms: [],
    codepromos: [],
    configurations: []
};

const fetchReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_ACTIVITES:
            return {
                ...state,
                activites: payload
            }
        case FETCH_OFFRES:
            return {
                ...state,
                offres: payload
            }
        case FETCH_FORMULES:
            return {
                ...state,
                formules: payload
            }
        case FETCH_ACCESSOIRES:
            return {
                ...state,
                accessoires: payload
            }
        case FETCH_ARTICLES:
            return {
                ...state,
                articles: payload
            }
        case FETCH_TACHES:
            return {
                ...state,
                taches: payload
            }
        case FETCH_ROOMS:
            return {
                ...state,
                rooms: payload
            }
        case FETCH_CODE_PROMOS:
            return {
                ...state,
                codepromos: payload
            }
        case FETCH_CONFIGURATIONS:
            return {
                ...state,
                configurations: payload
            }
        default:
            return state;
    }
}

export default fetchReducer